/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DetailsLoader_viewer$ref = any;
export type AggregateLevel = "DAY" | "MONTH" | "YEAR" | "%future added value";
export type FinancialAggregatedNumber = "accruedDeferred" | "actualCost" | "actualLockedRevenue" | "actualMargin" | "actualOpenRevenue" | "actualProfit" | "actualRevenue" | "actualRevenueMargin" | "actualRevenueProfit" | "allActualTimeAndExpenses" | "allForecastTimeAndExpensesToComplete" | "allPlannedTimeAndExpenses" | "allTotalTimeAndExpensesAtCompletion" | "allocationMinutes" | "baselineCost" | "baselineMargin" | "baselineMinutes" | "baselineProfit" | "baselineRevenue" | "baselineTimeAndExpenses" | "baselineVsActualCost" | "baselineVsActualMargin" | "baselineVsActualProfit" | "baselineVsActualRevenue" | "baselineVsActualRevenueMargin" | "baselineVsActualRevenueProfit" | "baselineVsActualRevenueRecognition" | "baselineVsBillableActualTimeAndExpenses" | "baselineVsBillableTotalTimeAndExpensesAtCompletion" | "baselineVsForecastCost" | "baselineVsForecastMinutes" | "baselineVsForecastProfit" | "baselineVsForecastRevenue" | "baselineVsRegisteredMinutes" | "baselineVsTotalCostAtCompletion" | "baselineVsTotalMarginAtCompletion" | "baselineVsTotalProfitAtCompletion" | "baselineVsTotalRevenueAtCompletion" | "baselineVsTotalRevenueMarginAtCompletion" | "baselineVsTotalRevenueProfitAtCompletion" | "baselineVsTotalTimeAtCompletion" | "billableActualMinutes" | "billableActualTimeAndExpenses" | "billableForecastTimeAndExpensesToComplete" | "billablePlannedTimeAndExpenses" | "billableTime" | "billableTotalTimeAndExpensesAtCompletion" | "estimatedCost" | "estimatedCostPercentage" | "expenseCostPercentage" | "expenseRevenuePercentage" | "forecastCost" | "forecastCostToComplete" | "forecastLockedRevenueToComplete" | "forecastMargin" | "forecastMarginToComplete" | "forecastMinutes" | "forecastOpenRevenueToComplete" | "forecastProfit" | "forecastProfitToComplete" | "forecastRevenue" | "forecastRevenueMarginToComplete" | "forecastRevenueProfitToComplete" | "forecastTimeToComplete" | "forecastVsScopeApprovedMinutes" | "invoiced" | "nonBillableActualMinutes" | "nonBillableActualTimeAndExpenses" | "nonBillableForecastTimeAndExpensesToComplete" | "nonBillablePlannedTimeAndExpenses" | "nonBillableTotalTimeAndExpensesAtCompletion" | "paid" | "planVsActualCost" | "planVsActualMargin" | "planVsActualProfit" | "planVsActualRevenue" | "planVsActualRevenueMargin" | "planVsActualRevenueProfit" | "planVsActualRevenueRecognition" | "planVsBillableActualTimeAndExpenses" | "planVsForecastCost" | "planVsForecastProfit" | "planVsForecastRevenue" | "planVsTotalBillableTimeAndExpensesAtCompletion" | "planVsTotalCostAtCompletion" | "planVsTotalMarginAtCompletion" | "planVsTotalProfitAtCompletion" | "planVsTotalRevenueAtCompletion" | "planVsTotalRevenueMarginAtCompletion" | "planVsTotalRevenueProfitAtCompletion" | "plannedCost" | "plannedMargin" | "plannedProfit" | "plannedRevenue" | "plannedRevenueMargin" | "plannedRevenueProfit" | "projectedTotalRevenueVsProjectedTotalBillableValueOfService" | "projectedTotalRevenueVsProjectedTotalValueOfService" | "recognitionActualProfit" | "recognitionActualProfitPercentage" | "recognitionAmount" | "recognitionForecastRevenue" | "recognitionLockedProfit" | "recognitionLockedProfitPercentage" | "recognitionLockedRevenue" | "recognitionOpenRevenue" | "recognitionPercentage" | "recognitionProfit" | "recognitionProfitPercentage" | "registeredMinutes" | "registeredVsScopeApprovedMinutes" | "remainingCost" | "remainingMargin" | "remainingMinutes" | "remainingProfit" | "remainingRevenue" | "retainerPeriodRolloverMinutes" | "retainerPeriodRolloverPrice" | "retainerPeriodTargetMinutes" | "retainerPeriodTargetPrice" | "scopeApprovedMinutes" | "scopeApprovedVsForecastMinutes" | "scopeApprovedVsRegisteredMinutes" | "scopeApprovedVsTotalTimeAtCompletion" | "scopeTotalMinutes" | "suggestedProfit" | "suggestedProfitPercentage" | "suggestedRevenue" | "suggestedRevenuePercentage" | "surplus" | "surplusPercentage" | "totalActualRevenueRecognition" | "totalCostAtCompletion" | "totalForecastRevenueToComplete" | "totalMarginAtCompletion" | "totalProfitAtCompletion" | "totalRevenueMarginAtCompletion" | "totalRevenueProfitAtCompletion" | "totalRevenueRecognition" | "totalTimeAtCompletion" | "totalTimeAtCompletionVsScopeApprovedMinutes" | "%future added value";
export type GLOBAL_FILTER_CONTEXT = "INVOICES" | "LABELS" | "PEOPLE" | "PLACEHOLDERS" | "PROJECTS" | "RESOURCES" | "SKILLS" | "TASKS" | "TIME_REGS" | "%future added value";
export type GLOBAL_FILTER_FIELD = "APPROVAL_STATUS" | "ASSIGNED" | "ASSIGNED_SELF" | "BILLABLE" | "BILLABLE_TIME_REG" | "BILL_FROM" | "BILL_TO" | "BLOCKED" | "BUG" | "CLIENT" | "CLIENT_GUEST_USERS" | "CLIENT_TIME_REG" | "COMPANY_TASK_ID" | "CONTACT" | "CREATED_AT" | "DEADLINE" | "DEPARTMENT" | "DEPARTMENT_TIME_REG" | "DEPENDENCIES" | "DESCRIPTION" | "END_DATE" | "END_DATE_PROJECT" | "END_DATE_TIME_REG" | "FILTER_BY_TIME_REG_SETTINGS" | "FOLLOWER" | "FORECAST" | "HIGH_PRIORITY" | "INTERNAL_TIME" | "INTERNAL_TIME_REG" | "INVOICED" | "LABELS" | "LABEL_TIME_REG" | "NAME" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "NON_TASK_TIME_REG" | "NO_CONTACT" | "OWNER" | "PERMISSION_LEVEL" | "PERSON" | "PERSON_TIME_REG" | "PHASE_CATEGORY" | "PHASE_TIME_REG" | "PRIORITY_LEVEL" | "PROGRAM" | "PROJECT" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "PROJECT_FOLLOWER" | "PROJECT_GROUP" | "PROJECT_GROUP_SPRINT" | "PROJECT_GROUP_STATUS" | "PROJECT_LABELS" | "PROJECT_MANUAL_PROGRESS" | "PROJECT_OWNER" | "PROJECT_PERSON" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_STAGE" | "PROJECT_STATUS" | "PROJECT_TIME_REG" | "PROJECT_WIN_CHANCE" | "RATE_CARD" | "RECENT_ACTIVITY" | "RECENT_TASK_ACTIVITY" | "RECENT_TIME" | "REMAINING" | "RETAINER_PERIOD" | "ROLE" | "ROLE_TIME_REG" | "SET_DONE_AT" | "SKILL" | "SPRINT_CATEGORY" | "SPRINT_TIME_REG" | "STARRED" | "START_DATE" | "START_DATE_PROJECT" | "START_DATE_TIME_REG" | "STATUS" | "SUB_TASKS" | "TASK" | "TASK_APPROVED" | "TASK_HIERARCHY" | "TASK_LEVEL" | "TASK_TIME_REG" | "TEAM" | "TEAM_MEMBER" | "TEAM_TIME_REG" | "TIME_OFF" | "TIME_OFF_TIME_REG" | "TIME_REGS" | "UPDATED_AT" | "WITH_TASKS" | "WITH_TIME_REG" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "ALL_IN" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "IN" | "IS" | "IS_ALL" | "IS_NOT" | "IS_NOT_ALL" | "LESS" | "LESS_OR_EQUAL" | "NOT_ALL_IN" | "NOT_IN" | "%future added value";
export type TaskSearchQueryType = {|
  filters?: ?$ReadOnlyArray<?GlobalSearchFilterType>
|};
export type GlobalSearchFilterType = {|
  field?: ?GLOBAL_FILTER_FIELD,
  operator?: ?GLOBAL_FILTER_OPERATOR,
  value?: ?$ReadOnlyArray<?string>,
  context?: ?GLOBAL_FILTER_CONTEXT,
  filters?: ?$ReadOnlyArray<?GlobalSearchFilterType>,
  logicalOperator?: ?GLOBAL_FILTER_LOGICAL_OPERATOR,
|};
export type DetailsLoader_QueryVariables = {|
  projectId: string,
  startYear?: ?number,
  startMonth?: ?number,
  startDay?: ?number,
  endYear?: ?number,
  endMonth?: ?number,
  endDay?: ?number,
  aggregateLevel: AggregateLevel,
  aggregates: $ReadOnlyArray<?FinancialAggregatedNumber>,
  searchQuery?: ?TaskSearchQueryType,
|};
export type DetailsLoader_QueryResponse = {|
  +viewer: ?{|
    +actualPersonId: ?string,
    +component: ?string,
    +$fragmentRefs: DetailsLoader_viewer$ref,
  |}
|};
export type DetailsLoader_Query = {|
  variables: DetailsLoader_QueryVariables,
  response: DetailsLoader_QueryResponse,
|};
*/


/*
query DetailsLoader_Query(
  $projectId: ID!
  $startYear: Int
  $startMonth: Int
  $startDay: Int
  $endYear: Int
  $endMonth: Int
  $endDay: Int
  $aggregateLevel: AggregateLevel!
  $aggregates: [FinancialAggregatedNumber]!
  $searchQuery: TaskSearchQueryType
) {
  viewer {
    actualPersonId
    component(name: "details_loader")
    ...DetailsLoader_viewer_1ScxAw
    id
  }
}

fragment DetailsLoader_viewer_1ScxAw on Viewer {
  id
  company {
    currency
    id
  }
  project(internalId: $projectId) {
    id
    useFixedPriceForBaselineRevenue
    rateCard {
      currency
      id
    }
    aggregatedFinancialNumbers(searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: $aggregateLevel, aggregates: $aggregates, convertToProjectCurrency: true)
    financialNumbers(searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, convertToProjectCurrency: true) {
      baselineRevenue
      baselineCost
      baselineProfit
      baselineMargin
      baselineVsBillableActualTimeAndExpenses
      baselineVsActualCost
      baselineVsActualProfit
      baselineVsActualMargin
      baselineVsActualRevenueProfit
      baselineVsActualRevenueMargin
      baselineVsActualRevenue
      baselineVsActualRevenueRecognition
      baselineVsTotalRevenueAtCompletion
      baselineVsBillableTotalTimeAndExpensesAtCompletion
      baselineVsTotalCostAtCompletion
      baselineVsTotalProfitAtCompletion
      baselineVsTotalRevenueProfitAtCompletion
      baselineVsTotalRevenueMarginAtCompletion
      billableActualTimeAndExpenses
      baselineTimeAndExpenses
      totalActualRevenueRecognition
      actualRevenue
      actualCost
      actualProfit
      actualMargin
      actualRevenueProfit
      actualRevenueMargin
      billablePlannedTimeAndExpenses
      plannedRevenue
      plannedCost
      plannedProfit
      plannedMargin
      plannedRevenueProfit
      plannedRevenueMargin
      billableForecastTimeAndExpensesToComplete
      totalForecastRevenueToComplete
      forecastCostToComplete
      forecastProfitToComplete
      forecastMarginToComplete
      forecastRevenueProfitToComplete
      forecastRevenueMarginToComplete
      billableTotalTimeAndExpensesAtCompletion
      totalRevenueRecognition
      totalCostAtCompletion
      totalProfitAtCompletion
      totalMarginAtCompletion
      totalRevenueProfitAtCompletion
      totalRevenueMarginAtCompletion
      planVsBillableActualTimeAndExpenses
      planVsActualRevenueRecognition
      planVsActualCost
      planVsActualProfit
      planVsActualMargin
      planVsActualRevenueProfit
      planVsActualRevenueMargin
      planVsTotalBillableTimeAndExpensesAtCompletion
      planVsTotalRevenueAtCompletion
      planVsTotalCostAtCompletion
      planVsTotalProfitAtCompletion
      planVsTotalMarginAtCompletion
      planVsTotalRevenueProfitAtCompletion
      planVsTotalRevenueMarginAtCompletion
      invoiced
      paid
      accruedDeferred
      baselineMinutes
      registeredMinutes
      billableActualMinutes
      nonBillableActualMinutes
      scopeApprovedMinutes
      forecastTimeToComplete
      totalTimeAtCompletion
      baselineVsRegisteredMinutes
      baselineVsTotalTimeAtCompletion
      registeredVsScopeApprovedMinutes
      scopeApprovedVsRegisteredMinutes
      totalTimeAtCompletionVsScopeApprovedMinutes
      scopeApprovedVsTotalTimeAtCompletion
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startYear",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startMonth",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startDay",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endYear",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endMonth",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endDay",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aggregateLevel",
    "type": "AggregateLevel!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aggregates",
    "type": "[FinancialAggregatedNumber]!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchQuery",
    "type": "TaskSearchQueryType"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "details_loader"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"details_loader\")"
},
v3 = {
  "kind": "Variable",
  "name": "aggregateLevel",
  "variableName": "aggregateLevel"
},
v4 = {
  "kind": "Variable",
  "name": "aggregates",
  "variableName": "aggregates"
},
v5 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v6 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v7 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v8 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v9 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v10 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v11 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  (v12/*: any*/)
],
v14 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DetailsLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              },
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "DetailsLoader_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DetailsLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "internalId",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useFixedPriceForBaselineRevenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v14/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "aggregatedFinancialNumbers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v14/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsBillableActualTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsActualCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsActualProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsActualMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsActualRevenueProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsActualRevenueMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsActualRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsActualRevenueRecognition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsTotalRevenueAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsTotalCostAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsTotalProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsTotalRevenueProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsTotalRevenueMarginAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableActualTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalActualRevenueRecognition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualRevenueProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualRevenueMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billablePlannedTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedRevenueProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedRevenueMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableForecastTimeAndExpensesToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalForecastRevenueToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastCostToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastProfitToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastMarginToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastRevenueProfitToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastRevenueMarginToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableTotalTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueRecognition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCostAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalMarginAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueMarginAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsBillableActualTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsActualRevenueRecognition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsActualCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsActualProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsActualMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsActualRevenueProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsActualRevenueMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalBillableTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalRevenueAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalCostAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalMarginAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalRevenueProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalRevenueMarginAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "invoiced",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accruedDeferred",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "registeredMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableActualMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nonBillableActualMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scopeApprovedMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastTimeToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalTimeAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsRegisteredMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsTotalTimeAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "registeredVsScopeApprovedMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scopeApprovedVsRegisteredMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalTimeAtCompletionVsScopeApprovedMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scopeApprovedVsTotalTimeAtCompletion",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "DetailsLoader_Query",
    "operationKind": "query",
    "text": "query DetailsLoader_Query(\n  $projectId: ID!\n  $startYear: Int\n  $startMonth: Int\n  $startDay: Int\n  $endYear: Int\n  $endMonth: Int\n  $endDay: Int\n  $aggregateLevel: AggregateLevel!\n  $aggregates: [FinancialAggregatedNumber]!\n  $searchQuery: TaskSearchQueryType\n) {\n  viewer {\n    actualPersonId\n    component(name: \"details_loader\")\n    ...DetailsLoader_viewer_1ScxAw\n    id\n  }\n}\n\nfragment DetailsLoader_viewer_1ScxAw on Viewer {\n  id\n  company {\n    currency\n    id\n  }\n  project(internalId: $projectId) {\n    id\n    useFixedPriceForBaselineRevenue\n    rateCard {\n      currency\n      id\n    }\n    aggregatedFinancialNumbers(searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: $aggregateLevel, aggregates: $aggregates, convertToProjectCurrency: true)\n    financialNumbers(searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, convertToProjectCurrency: true) {\n      baselineRevenue\n      baselineCost\n      baselineProfit\n      baselineMargin\n      baselineVsBillableActualTimeAndExpenses\n      baselineVsActualCost\n      baselineVsActualProfit\n      baselineVsActualMargin\n      baselineVsActualRevenueProfit\n      baselineVsActualRevenueMargin\n      baselineVsActualRevenue\n      baselineVsActualRevenueRecognition\n      baselineVsTotalRevenueAtCompletion\n      baselineVsBillableTotalTimeAndExpensesAtCompletion\n      baselineVsTotalCostAtCompletion\n      baselineVsTotalProfitAtCompletion\n      baselineVsTotalRevenueProfitAtCompletion\n      baselineVsTotalRevenueMarginAtCompletion\n      billableActualTimeAndExpenses\n      baselineTimeAndExpenses\n      totalActualRevenueRecognition\n      actualRevenue\n      actualCost\n      actualProfit\n      actualMargin\n      actualRevenueProfit\n      actualRevenueMargin\n      billablePlannedTimeAndExpenses\n      plannedRevenue\n      plannedCost\n      plannedProfit\n      plannedMargin\n      plannedRevenueProfit\n      plannedRevenueMargin\n      billableForecastTimeAndExpensesToComplete\n      totalForecastRevenueToComplete\n      forecastCostToComplete\n      forecastProfitToComplete\n      forecastMarginToComplete\n      forecastRevenueProfitToComplete\n      forecastRevenueMarginToComplete\n      billableTotalTimeAndExpensesAtCompletion\n      totalRevenueRecognition\n      totalCostAtCompletion\n      totalProfitAtCompletion\n      totalMarginAtCompletion\n      totalRevenueProfitAtCompletion\n      totalRevenueMarginAtCompletion\n      planVsBillableActualTimeAndExpenses\n      planVsActualRevenueRecognition\n      planVsActualCost\n      planVsActualProfit\n      planVsActualMargin\n      planVsActualRevenueProfit\n      planVsActualRevenueMargin\n      planVsTotalBillableTimeAndExpensesAtCompletion\n      planVsTotalRevenueAtCompletion\n      planVsTotalCostAtCompletion\n      planVsTotalProfitAtCompletion\n      planVsTotalMarginAtCompletion\n      planVsTotalRevenueProfitAtCompletion\n      planVsTotalRevenueMarginAtCompletion\n      invoiced\n      paid\n      accruedDeferred\n      baselineMinutes\n      registeredMinutes\n      billableActualMinutes\n      nonBillableActualMinutes\n      scopeApprovedMinutes\n      forecastTimeToComplete\n      totalTimeAtCompletion\n      baselineVsRegisteredMinutes\n      baselineVsTotalTimeAtCompletion\n      registeredVsScopeApprovedMinutes\n      scopeApprovedVsRegisteredMinutes\n      totalTimeAtCompletionVsScopeApprovedMinutes\n      scopeApprovedVsTotalTimeAtCompletion\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cad1bfc272a45f04b77a6137fae60eaf';

module.exports = node;
